import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <section className="section not-found">
      <div className="container centered narrow">
        <span className="error-code">404</span>
        <h1>{t("这个页面暂时找不到")}</h1>
        <p>{t("链接可能已经变化，返回首页继续了解云流加速器。")}</p>
        <Link className="button" to="/"><ArrowLeft /> {t("返回首页")}</Link>
      </div>
    </section>
  );
}
